import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
  window: {
    width: 0,
    height: 0,
  },
  snackbars: [],
};

const mutations = {
  SET_WINDOW_DIMENSIONS(state, data) {
    state.window.width = data.width;
    state.window.height = data.height - 150;
  },

  SET_SNACKBAR(state, snackbar) {
    state.snackbars = state.snackbars.concat(snackbar);
  },
};

const actions = {
  setWindowDimensions({ commit }, data) {
    commit("SET_WINDOW_DIMENSIONS", data);
  },

  setSnackbar({ commit }, snackbar) {
    snackbar.showing = true;
    snackbar.color = snackbar.color || "dark";

    commit("SET_SNACKBAR", snackbar);
  },
};

const getters = {
  isMobile: (state) => {
    //return true;
    return state.window.width < 768; // The same threshold as before
  },
};

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
});
